import * as React from "react";
import { cn } from "@/lib/utils";

const AvatarContext = React.createContext<{
  imageLoaded: boolean;
  setImageLoaded: (loaded: boolean) => void;
} | null>(null);

function Avatar({ className, ...props }: React.ComponentProps<"span">) {
  const [imageLoaded, setImageLoaded] = React.useState(false);
  return (
    <AvatarContext.Provider value={{ imageLoaded, setImageLoaded }}>
      <span
        className={cn(
          "relative flex size-8 shrink-0 overflow-hidden rounded-full bg-muted text-foreground",
          className,
        )}
        {...props}
      />
    </AvatarContext.Provider>
  );
}

function AvatarImage({ className, onLoad, onError, ...props }: React.ComponentProps<"img">) {
  const context = React.useContext(AvatarContext);
  return (
    <img
      className={cn("aspect-square size-full object-cover", className)}
      onLoad={(event) => {
        context?.setImageLoaded(true);
        onLoad?.(event);
      }}
      onError={(event) => {
        context?.setImageLoaded(false);
        onError?.(event);
      }}
      {...props}
    />
  );
}

function AvatarFallback({ className, ...props }: React.ComponentProps<"span">) {
  const context = React.useContext(AvatarContext);
  if (context?.imageLoaded) return null;
  return (
    <span
      className={cn(
        "absolute inset-0 grid place-items-center rounded-full bg-muted text-xs font-medium",
        className,
      )}
      {...props}
    />
  );
}

export { Avatar, AvatarFallback, AvatarImage };
